import { Icon } from 'components/Icon';
import { Color } from 'theme';

type Props = {
  size: number;
  initialColorName: Color | 'todo-replace-me';
  opacity?: number;
};

// TODO: add back animation
export function AnimatedCheckmark({ size, initialColorName, opacity }: Props) {
  return (
    <Icon
      name="simple-check"
      size={size}
      keepColorOnLoad
      initialColorName={initialColorName}
      opacity={opacity}
    />
  );
}
